import { render, staticRenderFns } from "./CodeGenerator.vue?vue&type=template&id=6bb4f286&scoped=true&"
import script from "./CodeGenerator.vue?vue&type=script&lang=js&"
export * from "./CodeGenerator.vue?vue&type=script&lang=js&"
import style0 from "./CodeGenerator.vue?vue&type=style&index=0&id=6bb4f286&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bb4f286",
  null
  
)

export default component.exports